export default "__VITE_ASSET__CWxfz8fq__"